import { render, staticRenderFns } from "./ktable.vue?vue&type=template&id=62a4a86a"
import script from "./ktable.vue?vue&type=script&lang=js"
export * from "./ktable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports